import { AddressStepOne, AddressStepThree, AddressStepTwo } from './steps';
import {
  initialValuesStepOne,
  initialTouchedStepOne,
  schemaStepOne,
} from './steps/One/validations';
import { schemaStepTwo } from './steps/Two/validations';
import {
  initialValuesStepThree,
  initialTouchedStepThree,
  schemaStepThree,
} from './steps/Three/validations';

export const ADDRESS_STEPS = {
  ONE: 'ONE',
  TWO: 'TWO',
  THREE: 'THREE',
};

export const TITLES_BY_STEPS = {
  [ADDRESS_STEPS.ONE]: 'Elegir dirección',
  [ADDRESS_STEPS.TWO]: 'Agregar dirección',
  [ADDRESS_STEPS.THREE]: 'Agregar dirección',
};

export const ADDRESS_INITIAL_VALUES = {
  [ADDRESS_STEPS.ONE]: initialValuesStepOne,
  [ADDRESS_STEPS.THREE]: initialValuesStepThree,
};

export const ADDRESS_INITIAL_TOUCHED = {
  [ADDRESS_STEPS.TWO]: initialTouchedStepOne,
  [ADDRESS_STEPS.THREE]: initialTouchedStepThree,
};

export const ADDRESS_SCHEMAS = {
  [ADDRESS_STEPS.ONE]: schemaStepOne,
  [ADDRESS_STEPS.TWO]: schemaStepTwo,
  [ADDRESS_STEPS.THREE]: schemaStepThree,
};

export const ADDRESS_FORMS = {
  [ADDRESS_STEPS.ONE]: AddressStepOne,
  [ADDRESS_STEPS.TWO]: AddressStepTwo,
  [ADDRESS_STEPS.THREE]: AddressStepThree,
};
